import * as React from "react";
const SvgLayers = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="layers_svg__svg-icon"
    style={{
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden",
    }}
    viewBox="0 0 1024 1024"
    data-icon="1"
    {...props}
  >
    <path d="m503.467 610.133-467.2-288 467.2-285.866 467.2 288-467.2 285.866zm-281.6-288L505.6 497.067l283.733-174.934-285.866-172.8-281.6 172.8z" />
    <path d="M789.333 518.4 503.467 691.2l-281.6-174.933L147.2 448 38.4 514.133l465.067 290.134L972.8 520.533 864 452.267z" />
    <path d="m787.2 712.533-283.733 172.8-281.6-177.066L147.2 640 36.267 708.267l467.2 290.133 467.2-285.867L864 646.4z" />
  </svg>
);
export default SvgLayers;
